export enum DevicesActionTypes {
  API_RESPONSE_SUCCESS = "@@devices/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@devices/API_RESPONSE_ERROR",

  GET_DEVICES = "@@devices/GET_DEVICES",
  UPDATE_DEVICES = "@@devices/UPDATE_DEVICES",
  UPDATE_DEVICES_AVAILABILTY = "@@devices/UPDATE_DEVICES_AVAILABILTY",
  ADD_DEVICES = "@@devices/ADD_DEVICES",
  DELETE_DEVICES = "@@devices/DELETE_DEVICES",
  CLEAR_ERROR = "@@devices/CLEAR_ERROR",
}
